module.exports = __webpack_public_path__ + "img/pic_login_bg@2x.cb9c2654.png";